import { X } from '@/components/icons'
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
} from './ui/drawer'
import { Button } from './ui/button'

interface ViewAnnouncementDrawerProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  announcement: {
    _id: string
    title: string
    message: string
    createdAt: number
  } | null
}

export function ViewAnnouncementDrawer({
  open,
  onOpenChange,
  announcement,
}: ViewAnnouncementDrawerProps) {
  if (!announcement) return null

  return (
    <Drawer open={open} onOpenChange={onOpenChange}>
      <DrawerContent className="max-h-[85dvh] flex flex-col">
        <DrawerHeader className="flex h-14 justify-between items-center px-4 py-0 border-b border-content-primary-inverse">
          <DrawerTitle className="text-lg font-bold leading-7 tracking-[-1px] text-content-primary-bold">
            Announcement
          </DrawerTitle>
          <DrawerClose asChild>
            <Button variant="secondary" size="icon" roundness="round" className="size-8">
              <X className="w-[14.75px] h-[14.75px]" />
            </Button>
          </DrawerClose>
        </DrawerHeader>

        <div className="min-h-0 flex-1 overflow-y-auto px-4 pt-4 pb-6">
          <div className="flex flex-col gap-4">
            <p className="text-base font-semibold leading-6 text-content-primary-bold">
              {announcement.title}
            </p>
            <p className="text-base font-normal leading-6 text-content-primary-bold whitespace-pre-wrap">
              {announcement.message}
            </p>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  )
}
